import { Alert, Button } from 'antd';
import { useContext, useEffect, useState } from 'react';
import styles from 'styles/components/inviteYourFriends.module.scss';
import { LOCAL_STORAGE } from 'utils/constants';
import { shareKarmaLinksModalFunction } from './shareKarmaLinksModalFunction';
import ProfileContext from 'services/profileContext';

const InviteYourFriends = () => {
  const { profile } = useContext(ProfileContext);
  const [isOpenAuthorized, setIsOpenAuthorized] = useState(false);

  useEffect(() => {
    const isOpenOk = localStorage.getItem(LOCAL_STORAGE.INVITE_CLOSED);
    setIsOpenAuthorized(
      !isOpenOk || isOpenOk.length === 0 || isOpenOk !== 'true'
    );
  }, []);

  const close = () => {
    localStorage.setItem(LOCAL_STORAGE.INVITE_CLOSED, 'true');
    setIsOpenAuthorized(false);
  };

  return isOpenAuthorized ? (
    <div className={styles.wrapper}>
      <Alert
        onClose={close}
        type="info"
        closable
        message={
          <div className={styles.content}>
            <div className={styles.contentLeft}>
              Refer to others and <b>earn $10 per signup</b>
              <Button
                type="primary"
                size="small"
                style={{ fontWeight: 'bold', marginLeft: 18, width: 150 }}
                onClick={() => shareKarmaLinksModalFunction(profile.inviteCode)}
              >
                Learn more
              </Button>
            </div>
          </div>
        }
        showIcon
      />
    </div>
  ) : (
    <></>
  );
};

export default InviteYourFriends;
